import React, { useState, useRef, useEffect } from 'react';
import i18n from '../i18n';
import '../styles/Hook/styles.css';
import { trackMatomoEvent } from '../utils/matomo';

const IconeGlobo = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <circle cx="12" cy="12" r="10"></circle>
    <line x1="2" y1="12" x2="22" y2="12"></line>
    <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"></path>
  </svg>
);

const useOutsideClick = (
  ref: React.RefObject<HTMLDivElement | null>,
  callback: () => void,
) => {
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (ref.current && !ref.current.contains(event.target as Node)) {
        callback();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [ref, callback]);
};

const LanguageSwitcher = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const availableLanguages = ['pt-br', 'en', 'de'];

  const dropdownRef = useRef<HTMLDivElement>(null);

  useOutsideClick(dropdownRef, () => {
    if (isMenuOpen) {
      setIsMenuOpen(false);
    }
  });

  const handleLanguageChange = (lang: string) => {
    trackMatomoEvent('Preference', 'language_change', lang);
    i18n.changeLanguage(lang);
    setIsMenuOpen(false);
  };

  const currentLanguage = i18n.language;

  return (
    <div className="language-switcher-container" ref={dropdownRef}>
      <button
        className="language-switcher-button"
        onClick={() => {
          trackMatomoEvent('Preference', 'language_menu_toggle');
          setIsMenuOpen(!isMenuOpen);
        }}
      >
        <IconeGlobo />
        <span>{currentLanguage}</span>
      </button>

      <div className={`language-menu ${isMenuOpen ? 'open' : ''}`}>
        {availableLanguages

          .filter((lang) => lang !== currentLanguage)

          .map((lang) => (
            <button key={lang} onClick={() => handleLanguageChange(lang)}>
              {lang.toUpperCase()}
            </button>
          ))}
      </div>
    </div>
  );
};

export default LanguageSwitcher;
